import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { publicRoutes, authRoutes } from './_core/router/routes'
import BaseLayout from './pages/auth/_layout/authLayout'
import './assets/scss/style.scss'
import 'primereact/resources/themes/saga-blue/theme.css'
import { PopupProvider } from './_core/contexts/popToast'
import { ContextAuth,useAuthState } from './_core/hooks/useAuth'
//import { useUserback } from '@userback/react'
//import { useRollbarPerson } from '@rollbar/react'

const App = () => {
  const [stateAuth,setAuth] = useAuthState()
  console.log('stateAuth',stateAuth)
  /*if(localStorage.getItem('ENVIRONMENT') === 'production')
  {
    try
    {
      useRollbarPerson(stateAuth.decoded)
    }
    catch(e)
    {
      console.log('Rollbar - error',e)
    }
    try
    {
      const userback = useUserback()
      React.useEffect(() => {
        userback.identify(stateAuth.userID,stateAuth.decoded)
      },[stateAuth])
    }
    catch(e)
    {
      console.log('Userback - error',e)
    }
  } */
  return (
    <ContextAuth.Provider value={[stateAuth,setAuth]}>
    <PopupProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          {publicRoutes.map((route) => (
            route((route) => <Route key={route.path} path={route.path} element={<route.component {...route.props}/>} />)
          ))}

          {/* Protected Routes */}
          {stateAuth.isAuthenticated ? (
            <Route path="/" element={<BaseLayout />}>
              {stateAuth.isOnboarded ? <>{
                authRoutes.map((route) =>
                  <Route key={route.path} path={route.path} element={<route.component/>} />
                )}</> : <>{
                  authRoutes.filter((route) => route.path === 'onboarding').map((route) =>
                    <Route key={route.path} path={route.path} element={<route.component/>} />
                  )}
                  <Route path="*" element={<Navigate to="/onboarding" replace />} />
                </>
              }
            </Route>
          ) : (
            <Route path="*" element={<Navigate to="/" replace />} />
          )}
        </Routes>
      </Router>
    </PopupProvider>
    </ContextAuth.Provider>
  )
}

export default App
